export default __webpack_public_path__ + "static/1-23885a35c353dc51f7581991046c2512.jpeg";